import type {
  SatelliteWebLandlordLeadManagementLinkDto,
  SatelliteWebLandlordLeadManagementTableRowResponseDto,
} from '@zg-rentals/ts-satellite-client';

type LeadWithNextStep = Pick<SatelliteWebLandlordLeadManagementTableRowResponseDto, 'nextStep'>;

type Options = {
  isButtonStyle?: boolean;
};

/**
 * Single source of truth for "does this lead have a next-step control to render", shared by the
 * table, cards, renter-details footer, and helper text. Returns the link when a control should
 * render, otherwise null. The tour-request step only renders as a table/cards text link; the
 * button-style footer CTA has no action for it.
 */
export default function getRenderableNextStepLink(
  lead: LeadWithNextStep | null | undefined,
  { isButtonStyle = false }: Options = {},
): SatelliteWebLandlordLeadManagementLinkDto | null {
  const link = lead?.nextStep?.link;
  if (!link) {
    return null;
  }
  if (isButtonStyle && link.linkId === 'nextStepViewTourRequest') {
    return null;
  }
  return link;
}
